export const recaptchaActionNames = {
  SIGNUP: "signup",
  LOGIN: "login",
};
